import {UserRole} from "../models/account";
import {FaUserClock} from "react-icons/fa";
import {MdAdminPanelSettings, MdPerson, MdStars} from "react-icons/md";
import React from "react";
import {t} from "i18next";

const roleIcons = {
    [UserRole.APPLIED]: FaUserClock,
    [UserRole.MEMBER]: MdPerson,
    [UserRole.ADMIN]: MdAdminPanelSettings,
    [UserRole.CREATOR]: MdStars,
} as const;

export function RoleIcon({role}: { role: UserRole }) {
    const tooltipText = t(`tours.membership.role.${role.toLowerCase()}`);
    const Icon = roleIcons[role];

    if (!Icon) return null;

    return <Icon title={tooltipText}/>;
}